import { createRouter, createWebHistory } from 'vue-router';

// 导入您的视图组件
import HomeView from '../views/HomeView.vue';
import ProfileView from '../views/ProfileView.vue';
import PgiosView from '../views/PgiosView.vue';
import AnzhuoView from '../views/AnzhuoView.vue';
import JcwinView from '../views/JcwinView.vue';
import MaciosView from '../views/MaciosView.vue';
import FriendsView from '../views/FriendsView.vue';
// ... 导入其他视图组件

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeView,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfileView,
  },
  
 
  {
    path: '/pgios',
    name: 'Pgios',
    component: PgiosView,
  },
  {
    path: '/anzhuo',
    name: 'Anzhuo',
    component: AnzhuoView,
  },
  {
    path: '/jcwin',
    name: 'Jcwin',
    component: JcwinView,
  },
  {
    path: '/macios',
    name: 'Macios',
    component: MaciosView,
  },
  {
    path: '/friends',
    name: 'Friends',
    component: FriendsView,
  },
  
  // ... 添加其他路由
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});


export default router;
